import React, { SVGProps } from 'react'

export const SecondActiveCenterSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="36"
    fill="none"
    viewBox="0 0 74 36"
    preserveAspectRatio="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M0 36h62.624c3.263 0 7.64-.043 11.376-1V4c-2.826-1.456-12.394-2.315-17.233-2.547C39.987.646 14.7.45 0 4.958V36Z"
    />
  </svg>
)
